
export default {
    getEstadoCivil(state) {
        return state.estadoCivil
    },
    getEstadosCivies(state) {
        return state.estadosCivies
    },
}